import { createAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import {
  DOCUMENT__DOCUMENT_PROGRESS_REJECT_FAILURE,
  DOCUMENT__DOCUMENT_PROGRESS_REJECT_REQUEST,
  DOCUMENT__DOCUMENT_PROGRESS_REJECT_SUCCESS,
  DOCUMENT__EMAIL_FAILURE,
  DOCUMENT__EMAIL_REQUEST,
  DOCUMENT__EMAIL_SUCCESS,
  DOCUMENT__INITIALIZE,
  DOCUMENT__SIGNING_CANCEL_FAILURE,
  DOCUMENT__SIGNING_CANCEL_REQUEST,
  DOCUMENT__SIGNING_CANCEL_SUCCESS,
} from '@app/store/actionTypes';
import { DocumentAttachmentsAction } from '@app/store/document/attachments/actions';
import { DocumentAuditTrailAction } from '@app/store/document/auditTrailFile/actions';
import { DocumentDataAction } from '@app/store/document/data/actions';
import { DocumentFileAction } from '@app/store/document/file/actions';

export function initializeDocument() {
  return {
    type: DOCUMENT__INITIALIZE,
  };
}

/**
 * 이미 서명 완료한 계약에 대해 자신의 서명을 취소한다.
 */
export function cancelSigning({
  documentId,
  participantId,
  message,
  isDocumentBlock,
}: {
  documentId: string;
  participantId: string;
  message: string;
  isDocumentBlock: boolean;
}) {
  return {
    type: DOCUMENT__SIGNING_CANCEL_REQUEST,
    payload: {
      documentId,
      participantId,
      message,
      isDocumentBlock,
    },
  };
}
export const cancelSigningSuccess = createAction(DOCUMENT__SIGNING_CANCEL_SUCCESS);
export function cancelSigningFailure(error: AxiosError) {
  return {
    type: DOCUMENT__SIGNING_CANCEL_FAILURE,
    payload: error,
    error: true,
  };
}

export function emailDocument(payload: {
  documentId: string;
  recipientEmail: string;
  senderName: string;
}) {
  return {
    type: DOCUMENT__EMAIL_REQUEST,
    payload,
  };
}
export function emailDocumentSuccess() {
  return {
    type: DOCUMENT__EMAIL_SUCCESS,
  };
}
export function emailDocumentFailure(error: AxiosError) {
  return {
    type: DOCUMENT__EMAIL_FAILURE,
    payload: error,
    error: true,
  };
}

/**
 * 문서 진행을 거절한다.
 */
export function rejectDocument({
  documentId,
  exitPath,
  participantId,
  message,
  isDocumentBlock,
}: {
  documentId: string;
  exitPath?: string;
  participantId: string;
  message: string;
  isDocumentBlock: boolean;
}) {
  return {
    type: DOCUMENT__DOCUMENT_PROGRESS_REJECT_REQUEST,
    payload: {
      documentId,
      participantId,
      message,
      isDocumentBlock,
      exitPath,
    },
  };
}
export const rejectDocumentSuccess = createAction(DOCUMENT__DOCUMENT_PROGRESS_REJECT_SUCCESS);
export function rejectDocumentFailure() {
  return {
    type: DOCUMENT__DOCUMENT_PROGRESS_REJECT_FAILURE,
  };
}

export type DocumentAction =
  | DocumentAttachmentsAction
  | DocumentAuditTrailAction
  | DocumentDataAction
  | DocumentFileAction
  | ReturnType<typeof initializeDocument>
  | ReturnType<typeof cancelSigning>
  | ReturnType<typeof cancelSigningSuccess>
  | ReturnType<typeof cancelSigningFailure>
  | ReturnType<typeof emailDocument>
  | ReturnType<typeof emailDocumentSuccess>
  | ReturnType<typeof emailDocumentFailure>
  | ReturnType<typeof rejectDocument>
  | ReturnType<typeof rejectDocumentSuccess>
  | ReturnType<typeof rejectDocumentFailure>;
